import { Const } from "@/const";
import { UserAgentHelper } from './userAgentHelper';

// Assetsを取り出す
export class ResourceHelper
{
    public static getResource(file : string)
    {
        // DL版はローカルから読み込む
        if (UserAgentHelper.isElectron()) {
            return require(`@/assets/${file}`);
        }
        return `${Const.IMAGE_URL_BASE}${file}`;
    }
}
